package system.network

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.soywiz.korma.interpolation.*
import component.*
import models.*
import org.jbox2d.common.*

class NetworkPhysicSyncSystem : IteratingSystem(family{ all(NetworkInputDataComponent, PhysicComponent)}) {

    private val INTERP_FACTOR = 0.95

    override fun onTick() {
        super.onTick()
    }

    override fun onTickEntity(entity: Entity) {
//        linearInterpolation(entity)
        applyDelta(entity)
    }

    private fun applyDelta(entity: Entity) {
        val physicCmp = entity[PhysicComponent]

        if (physicCmp.applyDelta) {
            physicCmp.body.setTransform(
                Vec2(physicCmp.posXd, physicCmp.posYd),
                physicCmp.body.angle
            )
            physicCmp.body.linearVelocityX = physicCmp.vXd
            physicCmp.body.linearVelocityY = physicCmp.vYd
            physicCmp.applyDelta = false

            println("dead recon applied")
        }

//        println("""
//            ${physicCmp.body.position.x}
//            ${physicCmp.body.position.y}
//            ${physicCmp.body.linearVelocityX}
//            ${physicCmp.body.linearVelocityY}
//        """.trimIndent())
    }

    private fun linearInterpolation(entity: Entity) {
        val physicCmp = entity[PhysicComponent]
        val inputDataComponent = entity[NetworkInputDataComponent]
        val body = physicCmp.body
        if (inputDataComponent.canReadPhysicState && inputDataComponent.physicData.isNotEmpty()) {
            val state = inputDataComponent.physicData.dequeue()
            body.linearVelocityX = state.velocityX
            body.linearVelocityY = state.velocityY

            // smoothing
//            val newX = 0.9.interpolate(body.position.x, state.x)
//            val newY = 0.9.interpolate(body.position.y, state.y)

            body.setTransform(Vec2(state.x, state.y), body.angle)
        }

//        if (inputDataComponent.physicData.isEmpty()) {
//            inputDataComponent.canReadPhysicState = false
//        }
    }

}
